import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { HealthCheckLocationStateType } from '../Types';
import { GenerateHealthCheckSlice } from './Types';

export const initialState: GenerateHealthCheckSlice = {
	activeStep: 0,
	isFinalized: false,
	id: 0,

	location: null,
};

export const generateHealthCheckSlice = createSlice({
	name: 'generateHealthCheck',
	initialState,
	reducers: {
		nextStep: (state) => {
			state.activeStep += 1;
		},
		previousStep: (state) => {
			if (state.activeStep === 0) {
				return;
			}

			state.activeStep -= 1;
		},
		reset: () => initialState,

		setLocation: (
			state,
			{ payload }: PayloadAction<HealthCheckLocationStateType>
		) => {
			state.location = payload;
		},
		setId: (state, { payload }: PayloadAction<number>) => {
			state.id = payload;
		},
		setStep: (state, { payload }: PayloadAction<number>) => {
			state.activeStep = payload;
		},
		setFinalized: (state, { payload }: PayloadAction<boolean>) => {
			state.isFinalized = payload;
		},
	},
});

export const {
	actions: {
		nextStep,
		previousStep,
		reset,

		setLocation,
		setStep,
		setFinalized,
		setId,
	},
} = generateHealthCheckSlice;

export default generateHealthCheckSlice.reducer;
